export const setItem = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.log(e);
  }
};

export const removeItem = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.log(e);
  }
};

export const getItem = (key) => {
  try {
    const localItem = sessionStorage.getItem(key);
    // No items ? Return null
    if (!localItem) {
      return null;
    }
    const item = JSON.parse(localItem);

    return item;
  } catch (e) {
    console.log(e);
    return null;
  }
};
